import { render, staticRenderFns } from "./DrugTabLinks.vue?vue&type=template&id=625e6b0a"
import script from "./DrugTabLinks.vue?vue&type=script&lang=js"
export * from "./DrugTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports